import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode } from "react";
import { formatBRL, type Centavos } from "@ida/core";
import "./ui.css";

type Variante = "primario" | "secundario" | "texto";

export function Botao({
  variante = "primario", bloco, children, ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variante?: Variante; bloco?: boolean }) {
  const classes = ["botao"];
  if (variante === "secundario") classes.push("botao--secundario");
  if (variante === "texto") classes.push("botao--texto");
  if (bloco) classes.push("botao--bloco");
  return <button className={classes.join(" ")} {...props}>{children}</button>;
}

export function Campo({
  rotulo, dica, ...props
}: InputHTMLAttributes<HTMLInputElement> & { rotulo: string; dica?: string }) {
  return (
    <label className="campo">
      <span className="campo__rotulo">{rotulo}</span>
      {dica && <span className="campo__dica">{dica}</span>}
      <input className="campo__entrada" {...props} />
    </label>
  );
}

/** Entrada de dinheiro: digita em reais, guarda em centavos. */
export function CampoMoeda({
  rotulo, dica, valor, aoMudar,
}: { rotulo: string; dica?: string; valor: Centavos; aoMudar: (c: Centavos) => void }) {
  return (
    <label className="campo">
      <span className="campo__rotulo">{rotulo}</span>
      {dica && <span className="campo__dica">{dica}</span>}
      <input
        className="campo__entrada"
        inputMode="decimal"
        placeholder="0,00"
        value={valor === 0 ? "" : (valor / 100).toFixed(2).replace(".", ",")}
        onChange={(e) => {
          const digitos = e.target.value.replace(/\D/g, "");
          aoMudar(digitos === "" ? 0 : Number(digitos));
        }}
      />
    </label>
  );
}

export function Cartao({
  children, tom,
}: { children: ReactNode; tom?: "acento" | "atencao" }) {
  const classes = ["cartao"];
  if (tom) classes.push(`cartao--${tom}`);
  return <div className={classes.join(" ")}>{children}</div>;
}

export function Destaque({
  valor, legenda,
}: { valor: Centavos; legenda: string }) {
  return (
    <div className="destaque">
      <span className="destaque__valor">{formatBRL(valor)}</span>
      <span className="destaque__legenda">{legenda}</span>
    </div>
  );
}

export function Linha({
  rotulo, valor, total,
}: { rotulo: string; valor: Centavos | string; total?: boolean }) {
  return (
    <div className={total ? "linha linha--total" : "linha"}>
      <span className="linha__rotulo">{rotulo}</span>
      <span className="linha__valor">
        {typeof valor === "string" ? valor : formatBRL(valor)}
      </span>
    </div>
  );
}

export function Selo({
  children, tom,
}: { children: ReactNode; tom?: "acento" | "atencao" }) {
  const classes = ["selo"];
  if (tom) classes.push(`selo--${tom}`);
  return <span className={classes.join(" ")}>{children}</span>;
}

export function Aviso({
  children, tom,
}: { children: ReactNode; tom?: "atencao" }) {
  return <p className={tom ? "aviso aviso--atencao" : "aviso"}>{children}</p>;
}
